import { EmbedData } from '../../store/editor/components/state'
import Component from 'vue-class-component'
import ComponentVue from './Component'
import InteractableComponent from './InteractableComponent'
import { Actions } from '../../store/editor/components/helpers'
import EmbedEditor from '../dialog/EmbedEditor.vue'

type MenuMode = 'top' | 'edit'

@Component({
  components: {
    'embed-editor': EmbedEditor
  }
})
export default class EmbedVue extends ComponentVue<EmbedData> {
  isEditorVisible: boolean = false
  private interactable: InteractableComponent

  get content(): string {
    return this.componentData.content
  }

  set content(content: string) {
    this.save(Object.assign({}, this.componentData, <EmbedData>{
      content
    }))
  }

  get isMaskVisible(): boolean {
    // コンテンツが空の場合、「クリックしてコードを編集」を直接クリック可能にしたいので、マスクを表示しない
    return !this.hasFocus && !!this.content
  }

  mounted(): void {
    this.enableFocus()
    this.interactable = new InteractableComponent(this.$el, this.$store)
    this.interactable.draggable({
      handle: '.embed-content__handle',
      extraTransform: 'scale(.7)'
    })
    this.interactable.droppable()
      .onDropTo((event) => {
        Actions.move(this.$store, {
          component: event.dropping,
          destination: this.componentData,
          direction: event.direction
        })
      })
  }

  destroyed(): void {
    this.interactable.destroy()
  }

  showEditor(): void {
    this.isEditorVisible = true
  }

  hideEditor(): void {
    this.isEditorVisible = false
  }

  saveContent(content: string): void {
    this.content = content
    this.hideEditor()
  }

  trackClose(): void {
    this.hideEditor()
  }

  trackInputEmbedText(): void {
  }
}
